<template>
	<div class="userbg ">
		<infoview :tabs="2"></infoview>
		<div class="userinfobg">

			<div class="userinfotop">
				<p>{{$t('OrderInfo.OrderInfo_1')}}</p>
				<span>{{$t('infoview.infoview_3')}}</span>
			</div>

			<div class="order">
				<el-row :gutter="20" class="orderitem">
					<el-col :span="7">
						<div class="orderbox">{{$t('OrderInfo.OrderInfo_2')}}</div>
					</el-col>
					<el-col :span="17">
						<div class="ordertext">{{form.TKAMSTID}}</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="orderitem">
					<el-col :span="7">
						<div class="orderbox">{{$t('OrderInfoDetail.OrderInfoDetail_1')}}</div>
					</el-col>
					<el-col :span="17">
						<div class="ordermoney">¥{{form.TKADFPRC}}</div>
					</el-col>
				</el-row>
				<el-row :gutter="20" class="orderitem">
					<el-col :span="7">
						<div class="orderbox">{{$t('OrderInfo.OrderInfo_6')}}</div>
					</el-col>
					<el-col :span="17">
						<div class="ordertext">{{form.TKAPAYNM}}</div>
					</el-col>
				</el-row>
			</div>
			<div>
				<el-form ref="form" :model="form">
					<el-form-item :label="$t('ReserveCar.ReserveCar_3')">
						<div class="reservelab row">
							<el-image style="width: 160px; height: 96px" :src="url" fit="contain"></el-image>
							<span>{{form.TKANAME1}}</span>
						</div>
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_4')">
						{{form.yytime}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_5')">
						{{form.value1}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_6')">
						{{form.type}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_7')" v-if="form.checked != ''">
						追加する（¥{{form.checked}}）
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_7')" v-else>
						-
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_8')" v-if="form.region">
						{{form.region}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_8')" v-else>
						{{$t('OrderInfoDetail.OrderInfoDetail_4')}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_9')" v-if="form.pernum">
						{{form.pernum}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_8')" v-else>
						{{$t('OrderInfoDetail.OrderInfoDetail_4')}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_10')">
						{{form.name}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_11')">
						{{form.secondname}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_12')">
						{{form.tel}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_13')">
						{{form.email}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_14')">
						{{form.suremail}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_15')">
						{{form.contray}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_16')">
						{{form.resource}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_17')">
						{{form.bx}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_18')">
						{{form.way}}
					</el-form-item>
					<el-form-item :label="$t('ReserveCar.ReserveCar_19')">
						{{form.zysx}}
					</el-form-item>
				</el-form>
			</div>
		</div>

	</div>
</template>

<script>
	import infoview from '../components/home/info/infoview.vue'

	export default {
		name: 'OrderInfo',
		components: {
			infoview
		},
		data() {
			return {

				form: {
					TKAMSTID: '',
					TKADFPRC: 0,
					TKAPAYNM: '',
					TKANAME1: '',
					yytime: '',
					value1: '',
					type: '',
					checked: '',
					region: '',
					pernum: '',
					name: '',
					secondname: '',
					tel: '',
					email: '',
					suremail: '',
					contray: '',
					resource: '',
					bx: '',
					way: '',
					zysx:'',
					
				},
				sMSTID: '',
				url: '',
				lang:0
			};
		},
		watch: {},
		computed: {},
		methods: {

			GetOrderByid() {
				console.log(this.$i18n.locale)
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				this.$api.post(this.$config.Get_Order_Byid, {
						'sPBAID': sessionStorage.getItem('log_mstid'),
						'sLNGCT': this.lang,
						'sMSTID': this.sMSTID
					},
					// 请求成功
					success => {
						console.log(success)
						this.form.TKAMSTID = success.KKDT[0].TKAMSTID
						this.form.TKADFPRC = success.KKDT[0].TKADFPRC
						this.form.TKADFPRC = (Number(this.form.TKADFPRC) || 0).toString().replace(
							/(\d)(?=(?:\d{3})+$)/g, '$1,')
						this.form.TKAPAYNM = success.KKDT[0].TKAPAYNM
						this.form.yytime = /\d{4}-\d{1,2}-\d{1,2}/g.exec(success.KKDT[0].TKASTAHO)[0]
						// console.log(/\d{2}:\d{1,2}/g.exec(success.KKDT[0].TKASTAHO)[0])
						this.form.value1 = /\d{2}:\d{1,2}/g.exec(success.KKDT[0].TKASTAHO)[0]
						this.form.TKANAME1 = success.KKDT[0].TKANAME1
						this.url = success.KKDT[0].MDQMLINK
						if (success.KKDT[0].INIHOURS) {
							this.form.type = success.KKDT[0].INIHOURS + '（¥' + (Number(success.KKDT[0].TKAHOURC) || 0)
								.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '）'
						}
						if (Number(success.KKDT[0].TKAADDAY) > 0) {
							this.form.checked = success.KKDT[0].TKAADDAY
							// this.form.checked = 210000000
							this.form.checked = (Number(this.form.checked) || 0).toString().replace(
								/(\d)(?=(?:\d{3})+$)/g, '$1,');
							// console.log(this.form.checked)
						}
						if (success.KKDT[0].TKAADUCT) {
							this.form.region = success.KKDT[0].TKAADUCT + this.$t('OrderInfoDetail.OrderInfoDetail_3')
						}
						if (success.KKDT[0].TKAKIDCT) {
							this.form.pernum = success.KKDT[0].TKAKIDCT + this.$t('OrderInfoDetail.OrderInfoDetail_3')
						}

						this.form.name = success.KKDT[0].TKAFAMNM
						this.form.secondname = success.KKDT[0].TKAGIVNM
						this.form.tel = success.KKDT[0].TKATELNO
						this.form.email = success.KKDT[0].TKAEMAIL
						this.form.suremail = success.KKDT[0].TKAEMAIL
						this.form.contray = success.KKDT[0].INICOYID
						this.form.resource = success.KKDT[0].INIDRIVE
						this.form.bx = success.KKDT[0].INIINNAM + '（¥' + (Number(success.KKDT[0].TKAINSRE) || 0)
							.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '）'
						this.form.way = success.KKDT[0].TKAPAYNM
						this.form.zysx=success.KKDT[0].INICOMNT;
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},

		},
		created() {

			this.sMSTID = this.$route.query.sMSTID
		},
		mounted() {
			this.GetOrderByid()
		}
	}
</script>

<style scoped>
	@media only screen and (min-width:680px) {
		.userbg {
			width: 80%;
			margin: 0 auto;
			padding: 60px 0;
			display: flex;
			flex-direction: row;
		}

		.userinfotop {

			margin-bottom: 45px;
		}

		.userinfotop>p {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
		}

		.order {
			padding-bottom: 28px;
			margin-bottom: 30px;
			width: 100%;
		}
	}

	@media only screen and (max-width:680px) {
		.userbg {
			width: 90%;
			margin: 0 auto;
			padding: 60px 0;
			padding-top: 10px;
		}

		.userinfotop {

			margin-bottom: 25px;
		}

		.userinfotop>p {
			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			margin-top: 20px;
		}

		.order {
			padding-bottom: 10px;
			margin-bottom: 30px;
			width: 100%;
		}
	}

	.userinfobg {
		width: 100%;
	}



	.userinfotop>span {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
	}


	.orderitem {
		width: 100%;
		padding: 0 12px;
		box-sizing: border-box;
		border-bottom: 1px solid #ddd;
		height: 60px;
		line-height: 60px;
		margin: 0 !important;
	}

	.orderbox {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
	}

	.ordertext {
		font-size: 14px;
		font-family: Roboto-Medium, Roboto;

	}

	.ordermoney {
		font-size: 24px;
		font-family: Roboto-Medium, Roboto;
		color: #E20000;
	}

	/deep/ .my-label {
		text-algin: center !important;
		width: 28%
	}

	.el-form {
		border: 1px solid #ddd;
		background-color: #FAFAFA;
	}

	.el-form-item {
		border-bottom: 1px solid #ddd;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/deep/ .el-form-item__label {
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center;
		height: 100%;
		background-color: #FAFAFA;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000;
		height: 60px;
		width: 28%;
	}

	/deep/ .el-radio-button__inner,
	.el-radio-group {
		line-height: 60px;
	}

	/deep/ .el-form-item__content {
		display: flex;
		align-items: center;
		padding: 10px 16px;
		line-height: 40px;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
		width: 72%;
		background-color: #fff;
		border-left: 1px solid #ddd;
		min-height: 60px;
	}

	.carlinbn {
		margin: 60px auto;
		width: 40%;
		height: 60px;
		background: #FF9C00;
		line-height: 60px;
		padding: 0 10px;
		box-sizing: border-box
	}

	.carlinbn>p {
		width: calc(100% - 16px);
		text-align: center;
		font-size: 24px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		color: #fff
	}

	.carlinbn>img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 23px;
	}

	.redtext {
		font-size: 24px;
		font-family: Roboto-Medium, Roboto;
		color: #E20000;
	}

	/deep/ .el-form-item:nth-child(1) .el-form-item__label {
		/* height: 136px; */
	}

	/deep/ .el-form-item:nth-child(1) .el-form-item__content {
		padding: 20px 16px;
	}

	.reservebtn {
		width: 22%;
		margin: 30px auto;
		text-align: center;
		background-color: #666666;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		color: #fff;
		height: 35px;
		line-height: 35px;
		margin-bottom: 80px
	}

	.reservelab {
		line-height: 30px;
		display: flex;
		align-items: center;
	}

	.reservelab>span {
		margin-left: 12px;
		font-size: 16px;
		font-family: Roboto-Bold, Roboto;
		display: block
	}
</style>
